import withFaceAndBodyCarousel from "../../../../FaceAndBodyCarousel/withFaceAndBodyCarousel";
import { useSelector } from "react-redux";
import ProductListingPage from "../../../../ProductListingPage/ProductListingPage";
import getCarouselCategory from "./getCarouselCategory";

const ProductListingPageWithFaceAndBodyCarousel = withFaceAndBodyCarousel(
  ProductListingPage
);

const ProductListingPageContainer = props => {
  const matchedCategory = useSelector(getCarouselCategory);

  let carouselProps = null;
  if (matchedCategory) {
    const { title, subtitle, carouselCatId } = matchedCategory;
    carouselProps = { title, subtitle, carouselCatId };
  }

  return (
    <ProductListingPageWithFaceAndBodyCarousel
      carouselProps={carouselProps}
      {...props}
    />
  );
};

export default ProductListingPageContainer;
